import { render } from "./disableDate.vue?vue&type=template&id=fa5cf7aa"
import script from "./disableDate.vue?vue&type=script&lang=js"
export * from "./disableDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__